import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import {withRouter} from 'react-router-dom'
import getProductList from './actions/getProductList'
import getProduct from './actions/getProduct'
import selectDocument from './actions/selectDocument'
import selectAllDocuments from './actions/selectAllDocuments'
import getZippedProducts from "./actions/getZippedProducts"
import getMergedProducts from "./actions/getMergedProducts"
import getEFF from "./actions/getEFF"
import Products from './components/index'

const mapStateToProps = (state) => {
    return ({
        data: state.briefing.products.data,
        blobUrl: state.briefing.products.blobUrl,
        isLoading: state.briefing.products.isLoading,
        selectedIds: state.briefing.products.selectedIds,
        loadingIds: state.briefing.products.loadingIds,
        loadingToolbarButtons: state.briefing.products.loadingToolbarButtons
    })
}

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators({
        getProductList,
        getProduct,
        selectDocument,
        selectAllDocuments,
        getMergedProducts,
        getZippedProducts,
        getEFF
    }, dispatch)
})

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(Products))



// WEBPACK FOOTER //
// ./src/screens/briefing/products/index.js